import axios from "../utils/axios";

// 🏢 Get address
export const GetCompanySetting = async (companyId) => {
  const response = await axios.get('/api/Company/GetSingleItem?id='+companyId);
  //console.log(response);
  return response.data;
};

export const getStoreInformation = async (storeid) => {
  const response = await axios.get("/api/Company/GetSingleItem", {
    params: { id: storeid },
    // headers: {
    //   Authorization: "Bearer " + localStorage.getItem("serviceToken"),
    // }
  });
  return response.data;
};

export const GetShopBanner =async (req)=>{
  const response = await axios.get('/api/Company/GetShopBanner', {
    params: { take: req },
    // headers: {
    //   Authorization: "Bearer " + localStorage.getItem("serviceToken"),
    // }
  });
  return response.data;
}


export const GetTopBanner = async (req)=> {
  const response=await axios.get('/api/Company/GetSellerTopBanner', {
    params: { take: req },
  })
  return response.data;
}